import { render } from "./NeedApproval.vue?vue&type=template&id=1faf238a"
import script from "./NeedApproval.vue?vue&type=script&lang=js"
export * from "./NeedApproval.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__